module.exports = __webpack_public_path__ + "static/media/fast_start.29bc8cf5.webm";